module.exports = __webpack_public_path__ + "567b193903a9f650004d6aedbaffab0d.MP3";